module.exports = __webpack_public_path__ + "static/Site-9-ead07ea96830809d36e64cc97f112f41.jpg";